import * as PIXI from 'pixi.js';
import { Scene } from "pixi-scenegraph";
import { createMenuItem, createPanel, createPopupPanel } from '@/ui/menu-builder';
import { HEIGHT, WIDTH } from "@/constants";
import { EVENT_BUS } from "@/model/event-bus";
import { bounce } from '@/util/tween';
import game from '@/model/game';
export class MenuScene extends Scene {
    activeItem = 0;

    constructor(sceneName = 'menu') {
        super(sceneName); // this is the scene name
        this.buttons = [];
        this.initBackground();
        this.initPanel();
        this.initButtons();
        this.initKeyHandlers();
    }

    initBackground() {
        const background = PIXI.Sprite.from('public/images/background.jpeg');
        background.width = WIDTH; background.height = HEIGHT;
        this.addChild(background);
    }

    initPanel() {
        const panel = createPanel({
            x: 40 + 150,
            y: 310,
            headerText: 'Piano Rocker'
        });
        this.addChild(panel);

    }

    initButtons() {
        const item1 = createMenuItem({
            text: 'Start', yCoord: 85 + 150 - 80 + 20,
            xCoord: 40 + 150,
            clickActionName: 'NAVIGATE',
            clickActionPayload: {
                sceneName: 'select-song'
            }
        });
        const item2 = createMenuItem({ 
            text: 'Practice', yCoord: 85 + 150 + 20, xCoord: 40 + 150,
            clickActionName: 'NAVIGATE',
            clickActionPayload: {
                sceneName: 'practice-mode-settings'
            }});
        const item3 = createMenuItem({
            text: 'Options', yCoord: 85 + 150 + 80 + 20, xCoord: 40 + 150,
            clickActionName: 'NAVIGATE',
            clickActionPayload: {
                sceneName: 'options'
            }
        });
        const item4 = createMenuItem({
            text: 'Quit', yCoord: 85 + 150 + 160 + 20, xCoord: 40 + 150,
            clickActionName: 'EXIT',
        });
        this.addChild(item1);
        this.addChild(item2);
        this.addChild(item3);
        this.addChild(item4);
        this.buttons = [item1, item2, item3, item4];
    }

    updateSelection() {
        this.buttons.forEach(button => {
            EVENT_BUS.emit('MENU_HOVER', { sprite: button, mouseOver: false });
        });
        EVENT_BUS.emit('MENU_HOVER', { sprite: this.buttons[this.activeItem], mouseOver: true });
    }

    initKeyHandlers() {
        EVENT_BUS.on('MENU_UP', (sceneName) => this.handleKeyEvent('MENU_UP', sceneName));
        EVENT_BUS.on('MENU_DOWN', (sceneName) => this.handleKeyEvent('MENU_DOWN', sceneName));
        EVENT_BUS.on('MENU_ENTER', (sceneName) => this.handleKeyEvent('MENU_ENTER', sceneName))
        EVENT_BUS.on('MENU_SCROLL_UP', (sceneName) => this.handleKeyEvent('MENU_SCROLL_UP', sceneName))
        EVENT_BUS.on('MENU_SCROLL_DOWN', (sceneName) => this.handleKeyEvent('MENU_SCROLL_DOWN', sceneName))
    }

    handleKeyEvent(eventName, sceneName) {
        if (sceneName !== this.Name) {
            return;
        }
        switch (eventName) {
            case 'MENU_UP': {
                this.activeItem--;
                if (this.activeItem < 0) {
                    this.activeItem = this.buttons.length - 1;
                }
                this.updateSelection();
                break;
            }
            case 'MENU_DOWN': {
                this.activeItem++;
                if (this.activeItem >= this.buttons.length) {
                    this.activeItem = 0;
                }
                this.updateSelection();
                break;
            }
            case 'MENU_ENTER': {
                const button = this.buttons[this.activeItem];
                const { clickActionName, clickActionPayload } = button.__meta
                EVENT_BUS.emit('MENU_CLICK', {
                    sprite: button,
                    actionName: clickActionName,
                    actionPayload: clickActionPayload
                });
                break;
            }
        }

    }

    showPopup({
        headerText = 'Popup Header',
        text = 'Popup Text',
    } = {}) {
        const mask = PIXI.Sprite.from('public/images/gradient.png');
        const popupPanel = createPopupPanel({
            headerText,
            text,
            onOK: () => {
                this.removeChild(popupPanel);
                this.removeChild(mask)
            }
        });
        mask.width = WIDTH;
        mask.height = HEIGHT;
        mask.position.set(WIDTH / 2, HEIGHT / 2);
        mask.anchor.set(0.5, 0.5);
        this.addChild(mask);
        this.addChild(popupPanel);
        bounce(popupPanel);
    }

    onReveal() {
        game.practiceMode = false;
    }

}